import { FC } from 'react';
import { MainContentFixedWidth } from 'modules/intelligentInsights/brandAffinityInsights/components/BrandAffinityMainContent.styles';
import { BrandAffinityBackground } from 'modules/intelligentInsights/brandAffinityInsights/components/layout/BrandAffinity.styles';
import { BrandAffinityMainHeader } from 'modules/intelligentInsights/brandAffinityInsights/components/BrandAffinityMainHeader';
import { AffinityTrendsBase } from 'modules/intelligentInsights/brandAffinityInsights/components/affinityTrends/AffinityTrendsBase';
import { AffinityBreakdownHeader } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/AffinityBreakdownHeader';
import { AffinityBreakdownTabs } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/AffinityBreakdownTabs';

export const BrandAffinityMainContent: FC = () => {
  return (
    <BrandAffinityBackground>
      <MainContentFixedWidth>
        <BrandAffinityMainHeader />
        <AffinityTrendsBase />
        <AffinityBreakdownHeader />
        <AffinityBreakdownTabs />
      </MainContentFixedWidth>
    </BrandAffinityBackground>
  );
};
